// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__KHIxG","arrow":"Tooltip_arrow__uIoGg","error":"Tooltip_error__Q8qY5","window":"Tooltip_window__DQAnG","content":"Tooltip_content__VR2Ys"};